import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import React from 'react'
import { TicketApi } from '../../../redux/api/TicketApi';
import { useReduxSelector } from '../../../redux/hooks';
import TicketGrid from './TicketGrid';
import { ITicketProps } from '../../../types/Ticket/ITicket';
import { PartialSpinny, SimpleSpinny, Spinny } from '../../Nav/Spinny';


const ExistingTickets: React.FC<ITicketProps> = (props) => {
    const { data: userProfile } = TicketApi.useGetUserProfileQuery();
    const contactUid = props.Contact?.UId || props.Company_Contact_Uid;
    const { data, isLoading } = TicketApi.useGetOpenEndUserTicketsQuery(contactUid, { skip: !contactUid })
    const { data: clientTickets, isLoading: clientLoading } = TicketApi.useGetOpenTicketsQuery({ companyId: props.Company_Id }, { skip: !props.Company_Id })

    //Remove the current contact's tickets from the client tickets
    let otherClientTickets = clientTickets
    if (data && otherClientTickets) {
        const contactTicketIds = data.map(t => t.ID);
        otherClientTickets = otherClientTickets.filter(t => !contactTicketIds.includes(t.ID));
    }

    if (isLoading || clientLoading) return <SimpleSpinny />

    return (
        <>
            <PanelBar expandMode='single'>
                <PanelBarItem selected={true} expanded={true} title={`(${data?.length}) ${props.Contact_Name}`} >
                    <TicketGrid data={data} />
                </PanelBarItem>
                <PanelBarItem selected={true} expanded={false} title={`(${otherClientTickets?.length}) ${props.Company_Name}`}  >
                    <TicketGrid data={otherClientTickets} primaryCol="Contact_Name" />
                </PanelBarItem>
            </PanelBar>

        </>
    )
}

export default ExistingTickets